import React from 'react'

function Icon({ fill = '#D16643' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="85"
      viewBox="0 0 86 85"
      fill="none"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M84.41 42.34A41.08 41.08 0 1143.34 1.26a41.07 41.07 0 0141.07 41.08v0z"
      ></path>
      <path
        fill={fill}
        d="M41.66 56.53v.38A1.892 1.892 0 0139.53 59H19.78a1.64 1.64 0 01-1.85-1.83v-.37a3.089 3.089 0 01.9-2.37l12-12.54c3.05-3.18 5.35-5.62 5.35-9a6.191 6.191 0 00-6.42-6.17c-3.52 0-6.2 2.43-7.17 5.82-.33 1.35-1.05 2-2.22 1.8l-.85-.12a1.91 1.91 0 01-1.78-2.45 11.91 11.91 0 0111.87-9.59c6.69 0 11.54 4.77 11.54 10.71 0 4.8-2.82 8-6.62 12l-8.93 9.57h13.93a1.88 1.88 0 012.13 2.07zm25.49-31.62v.35a1.862 1.862 0 01-2.1 2.07H53.14l-2.27 10A10 10 0 0157.54 35c6.34 0 11.39 5 11.39 12.19 0 7.19-5.52 12.44-13.07 12.44A13.66 13.66 0 0145.05 54a1.88 1.88 0 01.65-2.9l.37-.25c1.2-.8 2-.58 2.87.6A8.55 8.55 0 0055.86 55c4.67 0 8.17-3.3 8.17-7.82a7.682 7.682 0 00-7.89-8 9.72 9.72 0 00-6.25 2.63 2 2 0 01-2.3.42l-.32-.2c-.87-.51-1.37-1.03-1.17-2.13l3.12-15.24a2.071 2.071 0 012.3-1.87h13.53a1.88 1.88 0 012.1 2.12z"
      ></path>
    </svg>
  )
}

export default Icon
